export default __webpack_public_path__ + "static/media/loginImage.d7078415.svg";